export enum DeploymentStatus  {
    NotOnCloud = 'not on cloud',
    OnCloud = 'on cloud',
    PendingDeletion = 'pending deletion',
    PendingToConnect = 'pending to connect',
    PendingToCreate = 'pending to create',
    InProgress = 'inprogress'
 }
